import * as React from 'react';

import { InfoBar } from './info-bar';

function BottomBar() {
  return (
    <div className="sticky bottom-0 z-30 px-4 py-2 bg-white border-t shadow sm:hidden">
      <InfoBar />
    </div>
  );
}

export { BottomBar };
